module.exports = __webpack_public_path__ + "static/media/canal-new-light.ab451120.woff2";